import { z } from "zod";

export const CreateRolesSchema = z.object({
    name: z.string()
});

export type CreateRolesFormData = z.infer<typeof CreateRolesSchema>;